import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQueryEntity]' })
export class QueryEntityDirective
{
  constructor(public template: TemplateRef<any>) { }
}
